import React from "react";
// import {
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer
// } from "recharts";

import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


import styles from "./areaChart.module.scss"

// const data = [
//   {
//     name: "Page A",
//     uv: 4000,
//     pv: 2400,
//     amt: 2400,
//   },
//   {
//     name: "Page B",
//     uv: 3000,
//     pv: 1398,
//     amt: 2210,
//   },
//   {
//     name: "Page C",
//     uv: 2000,
//     pv: 9800,
//     amt: 2290,
//   },
//   {
//     name: "Page D",
//     uv: 2780,
//     pv: 3908,
//     amt: 2000,
//   },
//   {
//     name: "Page E",
//     uv: 1890,
//     pv: 4800,
//     amt: 2181,
//   },
//   {
//     name: "Page F",
//     uv: 2390,
//     pv: 3800,
//     amt: 2500,
//   },
//   {
//     name: "Page G",
//     uv: 3490,
//     pv: 4300,
//     amt: 2100,
//   },
// ];

const data = [
  {
    date: "2025-02-06",
    total_sum: 198
  },
  {
    date: "2025-02-07",
    total_sum: 175
  },
  {
    date: "2025-02-08",
    total_sum: 289
  },
  {
    date: "2025-02-09",
    total_sum: 134
  },
  {
    date: "2025-02-10",
    total_sum: 222
  }
  
];

export default function AreaChartComponent() {
  return (
    <ResponsiveContainer width="100%" height="100%">
    <BarChart
      data={data}
      margin={{
        top: 10,
        right: 30,
        left: 0,
        bottom: 0,
      }}
      className={styles.areaChart}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis />
      <Tooltip />
      <Bar dataKey="total_sum" fill="#6a5acd" activeBar={<Rectangle fill="#6a5acd" stroke="#6a5acd" />} />
    </BarChart>
    </ResponsiveContainer>
  );
}
